import { render, staticRenderFns } from "./StyleDetails.vue?vue&type=template&id=2478ca88&scoped=true&"
import script from "./StyleDetails.vue?vue&type=script&lang=js&"
export * from "./StyleDetails.vue?vue&type=script&lang=js&"
import style0 from "./StyleDetails.vue?vue&type=style&index=0&id=2478ca88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2478ca88",
  null
  
)

export default component.exports